// Module
var code = "<abx-room-list class=\"flat\" abx-building=\"vm.building\" abx-models=\"vm.rooms\" abx-fetch=\"vm.fetchRooms(skip, limit)\" abx-fetch-all=\"vm.fetchAllRooms(limit)\" abx-create-options=\"vm.createOptions\"> </abx-room-list> ";
// Exports
module.exports = code;